import map from 'lodash/map';

export default class UrlHelper {
    static getUrlParameters(url = window.location.href) {
        const parameterString = url
            .split('#')[0]
            .split('?')[1] || '';

        return parameterString
            .split('&')
            .reduce((params, parameter) => {
                const [ key, value ] = parameter.split('=');
                if (key) {
                    params[key] = value || '';
                }

                return params;
            }, {});
    }

    static assembleUrl({ url = window.location.href, parameters = {}, shouldMerge = true }) {
        let fragment;

        if (shouldMerge) {
            parameters = Object.assign(UrlHelper.getUrlParameters(url), parameters);
        }

        if (~url.indexOf('#')) {
            fragment = url.split('#')[1];
            url = url.split('#')[0];
        }

        const mappedParameters = new URLSearchParams();
        map(parameters, (value, key) => {
            if (Array.isArray(value)) {
                map(value, (valueItem) => {
                    mappedParameters.append(key + '[]', valueItem);
                });
            } else {
                mappedParameters.append(key, value);
            }
        });

        url = url.split('?')[0];
        if (mappedParameters.size) {
            url += '?' + mappedParameters.toString();
        }

        return `${url}${fragment ? `#${fragment}` : ''}`;
    }

    static isHomePage() {
        return location.pathname === '/';
    }

    static getCarSelectionURL({ url, parameters }, force = false) {
        let obj = {
            parameters
        };

        if (UrlHelper.isHomePage() || force) {
            obj.url = url;
        }

        return UrlHelper.assembleUrl(obj);
    }
}
